import React, { Component } from "react";
import SJNoData from '../../core/SJNoData'
import { Icon } from 'antd'



class InvDetSport extends Component {

    constructor(props) {
        super(props)
        let me = this
        this.state = {
            randomString: `_${this.createRandomString()}_`
        }

        this.getHotelAmenityList = this.getHotelAmenityList.bind(me)
    }
    createRandomString() {
        return Math.random().toString(36).substring(7)
    }
    getHotelAmenityList = (far) => {
           return far.map((fob, idx) => {
               let v= fob.description	
               return ( <p><span style={{fontSize: "16px"}} > <Icon  style={{ color: 'rgb(206, 209, 24)' }} type="sketch-square" theme="filled" /><text style={{paddingLeft: "10px"}}>I{v}</text></span></p>
               )
   
           })
    }
   


    render() {
        let hostRows = null
        const { data, fgtree } = this.props
        let far = []
        if(fgtree && fgtree['90'] && fgtree['90'].facilities.length > 0){
               far = fgtree['90'].facilities
        }
        console.log('jul8******')
        console.log(far)

        if (far && far.length > 0) {
            hostRows = this.getHotelAmenityList(far)
        } else {
            hostRows = <SJNoData />
        }
        
        return (
                <div className="card card--raised with-shadow">
                    <p className="sd-content"> <text> Sports </text></p>
                    <div className="svr-header2" style={{marginLeft:'14px'}}>   
                   
                            <p><span style={{fontSize: "16px"}} > <Icon  style={{ color: 'rgb(206, 209, 24)' }} type="sketch-square" theme="filled" /><text style={{paddingLeft: "10px"}}>Include Kinchen</text></span></p>
                            {hostRows}
                    </div>
                </div>
           
        )

    }

}

export default InvDetSport